import { ChangeDetectionStrategy, Component, inject, output, signal } from '@angular/core';
import { NavPopoverBase } from '../nav-icon/nav-popover-base';
import { NavigationItem } from '../../models/navigationItem';
import { NavigationService } from '../../navigation.service';

@Component({
	selector: 'bas-fav-nav-icon',
	templateUrl: './fav-nav-icon.component.html',
	styleUrls: ['../nav-icon/nav-icon.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class FavNavIconComponent extends NavPopoverBase {

	readonly favoriten = signal<Array<NavigationItem>>(null);
	readonly popoverOpened = output<FavNavIconComponent>();

	private readonly navigationService = inject(NavigationService);

	override onPopoverShow() {
		super.onPopoverShow();
		this.popoverOpened.emit(this);
		this.navigationService.getFavoriten()
			.subscribe(favoriten => this.favoriten.set(favoriten));
	}
}
